import { render, staticRenderFns } from "./FeedbackPage.vue?vue&type=template&id=3a577e9b&scoped=true&"
import script from "./FeedbackPage.vue?vue&type=script&lang=js&"
export * from "./FeedbackPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a577e9b",
  null
  
)

export default component.exports